module.exports = __webpack_public_path__ + "gadgets.svg?7a7f491609e27775380f666821a12013";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gadgets.svg
// module id = 119
// module chunks = 0